import {pageInfo, initUpdate, editData, originDetails, addData} from "../api";
import { supplierList, plant, cornSupplier} from '../../../../api'

const toxinExemptSetting = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    updateResp: null,
    supplierObj:null,
    plantObj:null,
    originTotal: null,
    originResp: null,
    originDetailsObj:null,
    cornSupplierObj: null,
    cornSupplierSearchObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    UPDATE_DATA(state, data){
      state.updateResp = data;
    },
    ADD_DATA(state, data){
      state.addSubmitResp = data;
    },

    SUPPLIER(state, data){
      state.supplierObj = data.obj;
    },
    PLANT(state, data){
      state.plantObj = data.obj;
    },

    ORIGIN_DETAILS_PAGEINFO(state, data){
      state.originDetailsObj = data.obj;
    },
    CORN_SUPPLIER_DATA(state, data){
      state.cornSupplierSearchObj = data.obj;
    },

  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //编辑提交
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('UPDATE_DATA', resp);
    },
    //新增提交
    async addSubmit({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //查询供应商下拉框
    async supplier({ commit }, obj) {
      let resp = await supplierList(obj);
      commit('SUPPLIER', resp);
    },
    //查询基地下拉框
    async plant({ commit }, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },

    //查询粮原地免检比例列表
    async originDetailsPageInfo({ commit }, obj) {
      let resp = await originDetails(obj);
      commit('ORIGIN_DETAILS_PAGEINFO', resp);
    },

    //查询供应商-远程搜索
    async cornSupplier({ commit }, obj) {
      let resp = await cornSupplier(obj);
      commit('CORN_SUPPLIER_DATA', resp);
    },
  }
}
export default toxinExemptSetting



// WEBPACK FOOTER //
// ./src/page/toxin/toxinExemptSetting/store/toxinExemptSetting.store.js